export default __webpack_public_path__ + "static/media/Frame-1.5fd48c69.png";